import React from 'react';
import { AdapterDateFns } from '../ui';
import { LocalizationProvider as MuiLocalizationProvider } from '../ui';

import { useUserPreferences } from './UserPreferencesContext';
import { getDateLocale } from '../utils/localization';

/**
 * Every date picker in the app, set to the region in Settings.
 *
 * Mounted once at the root rather than beside each picker. The two that wrapped
 * their own provider got the adapter's default locale, so a coach on `de-DE`
 * typed into a calendar with English month names starting on Sunday -- the same
 * complaint as `9/18/2026`, one control further in.
 */
export const PickerLocaleProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { preferences } = useUserPreferences();

  return (
    <MuiLocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={getDateLocale(preferences.region)}
    >
      {children}
    </MuiLocalizationProvider>
  );
};
